var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4590 -2755 17.89 22.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "spinner_svg__a",
    d: "m-4578.955-2752.8.6-.6a1 1 0 0 0-1.4-1.4l-2 2-.2.3a1 1 0 0 0 0 .8l.2.3 2 2a1 1 0 0 0 1.6-1.1 7 7 0 0 1 .6 12.4 1 1 0 0 0 .5 1.9h.5a9 9 0 0 0-2.4-16.5ZM-4580.155-2736.5l-.2-.3-2-2a1 1 0 0 0-1.6 1.1 7 7 0 0 1-.6-12.4 1 1 0 0 0-1-1.7 9 9 0 0 0 2.4 16.5l-.6.6a1 1 0 1 0 1.4 1.4l2-2 .2-.3a1 1 0 0 0 0-.9Z"
  })));
};
export default SvgSpinner;